import React from 'react';

const SubCareers = () => {
  return (
    <section className='sub-text-box' id='sub-text-box'>
      <h1>Careers</h1>
      <p>BUILD WITH US.</p>
    </section>
  );
};

export default SubCareers;
